import { useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../redux/slice/system";
import { useAbortedEffect } from "./hooks";
import { ProjectAPI } from "../axios/api";

import ModuleChartSingleView from "./chartSingleView";
import { formatOptions } from "../service/common";
import { option_diagram } from "../service/option/diagram";

export default function ModuleChartMultiView({ mappingURLID }) {
  const dispatch = useDispatch();
  const [apiData, setApiData] = useState({});
  const [viewState, setViewState] = useState("loading");
  const latestRequestIdRef = useRef(0);
  const optionData = useMemo(
    () => ({
      ...formatOptions(
        { diagram: option_diagram },
        { uniqueKey: "path", showLabel: "label" }
      ),
    }),
    []
  );

  useAbortedEffect((signal) => {
    if (!mappingURLID) {
      setViewState("notFound");
      return;
    }

    setViewState("loading");
    dispatch(setProgress({ show: true }));
    const requestId = ++latestRequestIdRef.current;

    ProjectAPI.getProjectDetail({
      path: `/${mappingURLID}`,
      options: { signal },
    }).then((result) => {
      if (requestId !== latestRequestIdRef.current) return;

      let { Response, data, message } = result;

      if (Response === 1) {
        const chartPaths =
          typeof data?.url === "string"
            ? data.url.split("*,*").filter(Boolean)
            : [];
        const validCharts = chartPaths.filter((chartPath) => {
          const moduleData = optionData.diagram_obj?.[chartPath];
          const groupData = option_diagram.find((group) =>
            (group.child || []).some((item) => item.path === chartPath)
          );

          return (
            !!moduleData &&
            !!groupData &&
            (groupData.systemWeb || []).includes(data.projectID)
          );
        });

        setApiData({ ...data, url: validCharts });
        setViewState(validCharts.length > 0 ? "ready" : "empty");
      } else if (!result.canceled) {
        setViewState(Response === 404 ? "notFound" : "error");
        dispatch(
          setToast({
            severity: "error",
            summary: message,
            detail: "",
          })
        );
      }

      dispatch(setProgress({ show: false }));
    });
  }, [mappingURLID, optionData]);

  return (
    <>
      {viewState === "loading" && (
        <div className="text-center p-3">圖表載入中</div>
      )}
      {viewState === "notFound" && (
        <div className="text-center text-red-400 p-3">無此 iframe 設定</div>
      )}
      {viewState === "empty" && (
        <div className="text-center text-red-400 p-3">
          目前無可顯示內容
        </div>
      )}
      {viewState === "error" && (
        <div className="text-center text-red-400 p-3">
          iframe 內容載入失敗
        </div>
      )}
      {viewState === "ready" && (
        <div className="grid">
          {(apiData.url || []).map((chart) => (
            <div key={chart} className="col-12 md:col-6">
              <ModuleChartSingleView
                systemWeb={apiData.projectID}
                moduleData={optionData.diagram_obj[chart]}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
}
